import { Outlet } from 'react-router-dom';

import { PortalNav } from '@/components/layouts/PortalNav';
// import { CopyrightBar } from '@/components/layouts/CopyrightBar';

/** Authenticated BFM Online (Barita) portal shell: top nav + routed content + footer. */
export function DashboardLayout() {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-white font-instrument text-barita-ink">
      <PortalNav />
      <main className="mx-auto w-full max-w-[1920px] flex-1">
        <Outlet />
      </main>
      {/* <CopyrightBar /> */}
    </div>
  );
}
